import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root',
})
export class EncrytionDecryptionHelperService {
    constructor() {}

    keySize = 256;
    ivSize = 128;
    saltSize = 256;
    iterations = 1000;

    /**
     * * all the above key size are in bits
     * * Note: "Rfc2898DeriveBytes" is c# based class which is used in encryption to generate secret key and "PBKDF2" for javascript
     * * We are "AES" algorithm for encryption which only accepts the specific key size for default key it is 32 bytes(256/8) and for IV it is 16 bytes(128/8) ref: <shorturl.at/ftIP6>
     * * iterations are by default 1000 ref: <shorturl.at/cvNR4>
     * * salt is a random string or padding which is appended to the plain text
     */

    // * method is used to encrypt the plain text
    encrypt(plainText: string, encryptionKey: string) {
        let salt = CryptoJS.lib.WordArray.random(this.saltSize / 8);
        let key = CryptoJS.PBKDF2(encryptionKey, salt, {
            keySize: this.keySize / 32,
            iterations: this.iterations,
            hasher: CryptoJS.algo.SHA256,
        });

        let iv = CryptoJS.lib.WordArray.random(this.ivSize / 8);

        let encrypted = CryptoJS.AES.encrypt(plainText, key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC,
        });

        let encryptedHex = this.base64ToHex(encrypted.toString());
        let base64result = this.hexToBase64(salt + iv + encryptedHex);

        return base64result;
    }

    // * method is used to decrypt the encryted text
    decrypt(encryptedText: string, decryptionKey: string) {
        let hexResult = this.base64ToHex(encryptedText);
        let salt = CryptoJS.enc.Hex.parse(hexResult.substring(0, 64));
        let iv = CryptoJS.enc.Hex.parse(hexResult.substring(64, 96));
        let encrypted = this.hexToBase64(hexResult.substring(96));

        let key = CryptoJS.PBKDF2(decryptionKey, salt, {
            keySize: this.keySize / 32,
            iterations: this.iterations,
            hasher: CryptoJS.algo.SHA256,
        });

        let decrypted = CryptoJS.AES.decrypt(encrypted, key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC,
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    // * helper method
    hexToBase64(str) {
        return btoa(
            String.fromCharCode.apply(
                null,
                str
                    .replace(/\r|\n/g, '')
                    .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
                    .replace(/ +$/, '')
                    .split(' ')
            )
        );
    }

    // * helper method
    base64ToHex(str) {
        let i, bin, hex;
        for (i = 0, bin = atob(str.replace(/[ \r\n]+$/, '')), hex = []; i < bin.length; ++i) {
            let tmp = bin.charCodeAt(i).toString(16);
            if (tmp.length === 1) tmp = '0' + tmp;
            hex[hex.length] = tmp;
        }
        return hex.join('');
    }
}
